import { render } from "./ErrorMessage.vue?vue&type=template&id=79040846&scoped=true"
const script = {}

import "./ErrorMessage.vue?vue&type=style&index=0&id=79040846&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79040846"]])

export default __exports__